<mat-card class="ui-wrapper">
    <mat-card-title>New {{ selectedCompanyType ? selectedCompanyType.type : "Company" }}</mat-card-title>
    <mat-stepper linear #stepper>
        <mat-step [stepControl]="companyDetailsForm">
            <ng-template matStepLabel>Company details</ng-template>
            <form class="mt-4" [formGroup]="companyDetailsForm">
                <h3 mat-card-subtitle>Company details</h3>
                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Company name</mat-label>
                                <input required data-testid="company-name" type="text" placeholder="Company name"
                                    aria-label="Company name" matInput formControlName="companyName">
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Phone number</mat-label>
                                <input required data-testid="company-phone-number" formControlName="phoneNumber"
                                    matInput placeholder="Phone number">
                                <mat-error *ngIf="companyDetailsForm.get('phoneNumber')?.invalid">
                                    Phone number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Alternative phone number</mat-label>
                                <input data-testid="company-phone-number-alt" formControlName="phoneNumberAlt" matInput
                                    placeholder="Alternative phone number">
                                <mat-error *ngIf="companyDetailsForm.get('phoneNumberAlt')?.invalid">
                                    Alternative phone number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Email address</mat-label>
                                <input required data-testid="company-email" formControlName="email" matInput
                                    placeholder="Email address">
                                <mat-error *ngIf="companyDetailsForm.get('email')?.invalid">
                                    Email address is invalid 
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Alternative email address</mat-label>
                                <input data-testid="company-email-alt" formControlName="emailAlt" matInput
                                    placeholder="Alternative email address">
                                <mat-error *ngIf="companyDetailsForm.get('emailAlt')?.invalid">
                                    Alternative email address is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Practice number</mat-label>
                                <input data-testid="company-practice-number" formControlName="practiceNumber" matInput
                                    placeholder="Practice number">
                                <mat-error *ngIf="companyDetailsForm.get('practiceNumber')?.invalid">
                                    Practice number is invalid 
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>VAT registration number</mat-label>
                                <input data-testid="company-vat-reg-number" formControlName="vatRegistrationNumber"
                                    matInput placeholder="VAT registration number">
                                <mat-error *ngIf="companyDetailsForm.get('vatRegistrationNumber')?.invalid">
                                    VAT registration number is invalid 
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Type</mat-label>
                                <mat-select required data-testid="company-type" formControlName="companyType">
                                    <mat-option *ngFor="let type of companyTypes" [value]="type">
                                        {{type.type}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="companyDetailsForm.get('companyType')?.invalid">
                                    Select type
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                </div>

                <div *ngIf="showDistributor" class="my-2">
                    <div class="py-2 mt-4">
                        <mat-divider></mat-divider>
                    </div>

                    <h3 mat-card-subtitle>Distributor</h3>

                    <p>
                        <button type="button" *ngIf="!selectedDistributor" mat-stroked-button
                            (click)="openSearchDistributorDialog()">
                            Select distributor
                        </button>
                    </p>

                    <div *ngIf="selectedDistributor" class="details mt-2">
                        <div>
                            <button type="button" mat-stroked-button (click)="deselectDistributor()" class="me-2 my-2">
                                <mat-icon>cancel</mat-icon> Remove
                            </button>
                            <table class="mt-4">
                                <tr>
                                    <th>
                                        Name
                                    </th>
                                    <td>
                                        {{ selectedDistributor.name ? selectedDistributor.name : "-" }}
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        Alternative email address
                                    </th>
                                    <td>
                                        {{
                                        selectedDistributor.email_alt ? selectedDistributor.email_alt :
                                        "-"
                                        }}
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        Phone number
                                    </th>
                                    <td>
                                        {{
                                        selectedDistributor.phone_number ?
                                        selectedDistributor.phone_number :"-"
                                        }}
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        Email
                                    </th>
                                    <td>
                                        {{ selectedDistributor.email ? selectedDistributor.email : "-"
                                        }}
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        Alternative phone number
                                    </th>
                                    <td>
                                        {{ selectedDistributor.phone_number_alt ?
                                        selectedDistributor.phone_number_alt : "-" }}
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        Practice number
                                    </th>
                                    <td>
                                        {{ selectedDistributor.practice_number ?
                                        selectedDistributor.practice_number : "-" }}
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        VAT registration number
                                    </th>
                                    <td>
                                        {{ selectedDistributor.vat_registration_number ?
                                        selectedDistributor.vat_registration_number : "-" }}
                                    </td>
                                </tr>

                            </table>
                        </div>
                    </div>
                </div>

                <div class="text-end mt-2">
                    <button data-testid="next-step" [disabled]="!companyDetailsForm.valid" class="mx-1" color="primary"
                        mat-raised-button matStepperNext>
                        <mat-icon>chevron_right</mat-icon> Next
                    </button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="addressDetailsForm">
            <ng-template matStepLabel>Address details</ng-template>
            <form [formGroup]="addressDetailsForm">

                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Search for a country</mat-label>
                                <input required [disabled]="isLoading" type="text" placeholder="Search for a country"
                                    aria-label="Search for a country" matInput formControlName="country"
                                    [matAutocomplete]="auto">
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                    <mat-option *ngFor="let country of filteredCountriesForIndividual | async"
                                        [value]="country.name">
                                        {{country.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matPrefix>search</mat-icon>
                                <mat-error *ngIf="addressDetailsForm.get('country')?.invalid">
                                    Country is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Province</mat-label>
                                <mat-select required data-testid="individual-province" formControlName="province">
                                    <mat-option *ngFor="let province of provinces" value="{{province.name}}">
                                        {{province.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addressDetailsForm.get('province')?.invalid">
                                    Province is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>City</mat-label>
                                <input type="text" formControlName="city" matInput/>
                                <mat-error *ngIf="addressDetailsForm.get('city')?.invalid">
                                    City is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Address line 1</mat-label>
                                <input required data-testid="individual-address-line-1" formControlName="addressLine1"
                                    matInput placeholder="Address Line 1">
                                <mat-error *ngIf="addressDetailsForm.get('addressLine1')?.invalid">
                                    Address Line 1 is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Suburb</mat-label>
                                <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput
                                    placeholder="Suburb">
                                <mat-error *ngIf="addressDetailsForm.get('addressLine2')?.invalid">
                                    Suburb is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building Number</mat-label>
                                <input data-testid="individual-building-apt-number" formControlName="buildingAptNumber"
                                    type="number" min="1" matInput placeholder="Building Number">
                                <mat-error *ngIf="addressDetailsForm.get('buildingAptNumber')?.invalid">
                                    Building Number is required
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Postcode</mat-label>
                                <input required data-testid="individual-postcode" formControlName="postcode" matInput
                                    placeholder="Postcode">
                                <mat-error *ngIf="addressDetailsForm.get('postcode')?.invalid">
                                    Postcode is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                </div>

            </form>

            <div class="text-end">

                <button class="mx-1" data-testid="previous-step" color="primary" mat-raised-button matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon> Back
                </button>

                <button data-testid="next-step" (click)="save()"
                    [disabled]="!companyDetailsForm.valid || !addressDetailsForm.valid" class="mx-1" color="primary"
                    mat-raised-button>
                    <mat-icon>save</mat-icon> Save
                </button>
            </div>
        </mat-step>
    </mat-stepper>
</mat-card>